import { ActionFunctionArgs, LoaderFunctionArgs, redirect, Form, useActionData, useNavigation, Link } from 'react-router'
import { z } from 'zod'
import { parseWithZod } from '@conform-to/zod'
import { useForm } from '@conform-to/react'
import { redirectIfUserLoggedIn } from '~/auth/AuthorizeRouteAccess'
import { verifyPasswordAndSendOtp } from '~/application/auth/verifyPasswordAndSendOtp'
import { AuthPageLayout } from '~/ui/auth/AuthPageLayout'
import { setOtpVerificationEmail } from '~/auth/otpVerificationSessionStorage'
import { routes } from '@application/Routes'

export async function loader({ request }: LoaderFunctionArgs ) {
	await redirectIfUserLoggedIn(request)
	return {}
}

export default function Login() {
	const navigation = useNavigation()
	const lastResult = useActionData<typeof action>()
	const [form] = useForm({
		shouldValidate: 'onSubmit',   
		lastResult,
	})
	return (
		<AuthPageLayout>
			<Form
				className="mt-10 w-full max-w-md bg-primary-color px-5 pt-20 flex flex-col gap-5"
				method="POST"
			>
				<label className="flex flex-col">
					<span className="font-h2 text-text-default-color">Enter your Email</span>
					<input
						type="email"
						name="email"
						className="textfield text-text-default-color h-8 focus:outline-none"
						data-testid="email-login"
					/>
				</label>

				<div className="flex flex-col">
					<label htmlFor="password" className="font-h2 text-text-default-color">
						Enter your Password
					</label>

					<input
						id="password"
						type="password"
						name="password"
						className="textfield text-text-default-color h-8 focus:outline-none"
						data-testid="password-login"
					/>
					
					<Link 
						to="/forgot-password" 
						className="text-green-color font-h3 hover:underline my-5"
					>
						Forgot your password?
					</Link>

				</div>

				<div className="text-red-700">{form.errors}</div>
				<button 
					type="submit"
					disabled={navigation.state !== 'idle'}
					className={'button submit w-[8.5rem]'}
				>
					Log In
				</button>

			</Form>
		</AuthPageLayout>
	)
}
const schema = z.object({
	email: z.string(),
	password: z.string(),
	register: z.string().optional(),
})

export async function action({ request }: ActionFunctionArgs) {
	const data = await request.formData()
	const submission = parseWithZod(data, { schema })

	if (submission.status !== 'success') {
		return submission.error
	}

	const { email, password } = submission.value

	const result = await verifyPasswordAndSendOtp(email, password)

	if (result.success === false) {
		return submission.reply({
			formErrors: [result.error],
		})
	}

	const otpVerificationCookie = await setOtpVerificationEmail(request, email)

	return redirect(routes.auth.verifyOtp, {
		headers: {
			...otpVerificationCookie,
		},
	})
}
